import {Configuration, Token} from "@devour/client";
import {store} from "@/redux";

export default function getConfig(fullToken?: Token, basePath?: string): Configuration {
    const _fullToken = fullToken || store.getState().authStore.fullToken;
    const rttrStore = store.getState().rttrStore;
    const realmUuid = rttrStore?.realmUuid;
    const realmTs = rttrStore?.realmTs;
    const realmSig = rttrStore?.realmSig;

    const headers: Record<string, string> = {};
    if (_fullToken?.token) {
        headers.authorization = `Bearer ${_fullToken.token}`;
    }
    if (realmUuid) {
        headers["X-Realm-UUID"] = realmUuid;
    }
    if (realmTs) {
        headers["X-Realm-TS"] = realmTs;
    }
    if (realmSig) {
        headers["X-Realm-Sig"] = realmSig;
    }

    // Always provide basePath from environment variable or parameter
    const finalBasePath = basePath || import.meta.env.VITE_BACKEND_REST_URL;

    if (!finalBasePath) {
        throw new Error("VITE_BACKEND_REST_URL environment variable is not set. Please check your .env file.");
    }

    /*
     * Pass `headers: undefined` rather than `{}` when no auth/identity is set so
     * the @devour/client Configuration falls back to its built-in defaults. An
     * empty object would replace those defaults and strip Content-Type / Accept.
     */
    return new Configuration({
        headers: Object.keys(headers).length > 0 ? headers : undefined,
        basePath: finalBasePath,
    });
}

export function getMagicConfig(magicCredential: string): Configuration {
    if (!import.meta.env.VITE_BACKEND_REST_URL) {
        throw new Error("VITE_BACKEND_REST_URL environment variable is not set. Please check your .env file.");
    }
    return new Configuration({
        headers: {
            "authorization": `Bearer ${magicCredential}`,
        },
        basePath: import.meta.env.VITE_BACKEND_REST_URL,
    });
}